import { AgentConfig } from '../services/organizationService';

/**
 * Default agent configuration extracted from the hardcoded AGENT_IDS in fillyConstants.ts.
 * These are used as fallback when an organization has no agentConfig set.
 * 
 * When the backend consumption phase is implemented, the resolved agent config
 * (org override → this default) will be passed to IRIS API calls.
 */
export const DEFAULT_AGENT_CONFIG: AgentConfig = {
  chat: 'b663f15e-7d9f-4812-bb84-a6f57998d71c',
  finaljson: 'f01befd7-6ef0-441e-926b-0851e48b9951',
  explore: 'c1a7e3b7-55c0-4cb8-88c1-568517e2a65d',
  narrative: '950820e9-0d95-4330-8f47-888cd03fb776',
  prioritize: 'eec5ab1f-deb7-4ef3-91ed-741193debbee',
};